export default __webpack_public_path__ + "static/media/up-caret.bdd5a0b1.svg";